import {
  CButton,
  CCardHeader,
  CCol,
  CDataTable,
  CInputGroup,
  CLabel,
  CRow,
  CSpinner,
} from "@coreui/react";
import React, { useState } from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import csvFile from "../../assets/files/Lot.csv";

const LotExcel = () => {
  const [loading, setloading] = useState(false);
  const [loadingForUpload, setloadingForUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [usersData, setuserData] = useState();
  const [distplayStatus, setdistplayStatus] = useState(false);
  const [disableBtn, setdisableBtn] = useState(true);
  const [uploadBtn, setuploadBtn] = useState(false);
  const [validMsg, setvalidMsg] = useState("");

  const validateData = async () => {
    //let duplicated = false;
    setloading(true);

    // const file = document.getElementById("inputGroupFile01");
    const header = new Headers();
    //header.append("", "");
    const data = new FormData();

    data.append("file", selectedFile);
    const response = await apiCall(
      `LotDetails/ValidateUpload`,
      "POST",
      header,
      data
    );
    const jsonobj = await response.json();

    if (response.status === 200) {
      setuserData(jsonobj);
      setdistplayStatus(true);
      setdisableBtn(true);
      setloading(false);
      setvalidMsg("");

      if (jsonobj.find((e) => e.status !== "Success")) {
        // jsonobj.find((e) => e.status === "abcd")
        //duplicated = true;
        setuploadBtn(false);
      } else {
        //duplicated = false;
        setuploadBtn(true);
      }
    } else if (response.statusText === "Bad Request") {
      setloading(false);
      setvalidMsg("Please insert valid file");
      setuploadBtn(false);
      setdisableBtn(true);
    } else if (response.status === 500) {
      setloading(false);
      setuploadBtn(false);

      setdisableBtn(true);
      setvalidMsg("please select file ");
    } else {
      setloading(false);
      setuploadBtn(false);

      setuserData("");
    }
  };

  const UploadData = async () => {
    setloadingForUpload(true);

    const header = new Headers();
    const uploadData = new FormData();
    uploadData.append("file", selectedFile);
    header.append("Accept", "application/json");
    const uploadResponse = await apiCall(
      `LotDetails/Upload`,
      "POST",
      header,
      uploadData
    );
    const uploadjsonobj = await uploadResponse.json();
    if (uploadjsonobj.statusText === "OK") {
      // setuserData(uploadjsonobj)
      setdistplayStatus(false);
      setdisableBtn(true);
      setloadingForUpload(false);
      setuploadBtn(false);
    } else {
      setdistplayStatus(false);
      setloadingForUpload(false);
      setuploadBtn(false);
    }
  };
  const UploadAgreementData = async () => {
    if (selectedFile === null || selectedFile === undefined) {
      alert("Please upload file");
    } else {
      setloadingForUpload(true);
      const header = new Headers();
      const uploadAgreementData = new FormData();
      uploadAgreementData.append("file", selectedFile);
      header.append("Accept", "application/json");
      const uploadResponse = await apiCall(
        `LotDetails/TenderDocumentsUpload`,
        "POST",
        header,
        uploadAgreementData
      );
      await uploadResponse.json();
      if (uploadResponse.status === 200) {
        // setuserData(uploadjsonobj)
        setdistplayStatus(false);
        setdisableBtn(true);
        setloadingForUpload(false);
        setuploadBtn(false);
      } else {
        setdistplayStatus(false);
        setloadingForUpload(false);
        setuploadBtn(false);
      }
    }
  };

  const changeHandler = (e) => {
    setSelectedFile(e.target.files[0]);
    setdisableBtn(false);
    setvalidMsg("");
  };
  const changeUploadHandler = (e) => {
    setSelectedFile(e.target.files[0]);
    setvalidMsg("");
  };

  const fields = [
    {
      key: "srNo",
      label: "Sr No",
    },
    {
      key: "ShowSpan",
      label: <div>Status</div>,
      _style: { width: "50px" },
    },
    {
      key: "tenderNo",
      label: "Tender number",
    },
    {
      key: "companyName",
      label: "Company Name",
    },
    {
      key: "company_Category",
      label: "Company Category",
    },
    {
      key: "district",
      label: "District",
    },
    {
      key: "emailId",
      label: "EmailId",
    },
    {
      key: "emdAmount",
      label: "Emd Amount",
    },
    {
      key: "LotNumber",
      label: "Lot number",
    },
    {
      key: "name",
      label: "Name",
    },
    {
      key: "priority",
      label: "Priority",
    },
    {
      key: "prop_name",
      label: "Prop Name",
    },
    {
      key: "purchasePrice",
      label: "Purchase Price",
    },
    {
      key: "purchaseRate",
      label: "Purchase Rate",
    },
    {
      key: "qty",
      label: "Qty",
    },
    {
      key: "socity",
      label: "Society",
    },
  ];

  return (
    <>
      <CCardHeader className="mb-3 shadow-sm">
        <CRow className="pt-3" xl={12}>
          <CCol xl={10}>
            <h3>Import Lot - Excel Sheet</h3>
          </CCol>
        </CRow>
        <hr />
        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Lot Excel Sheet
            </CLabel>
          </CCol>
          <CCol xl={4}>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  onChange={
                    distplayStatus ? changeUploadHandler : changeHandler
                  }
                  id="inputGroupFile01"
                  type="file"
                  accept=".csv"
                  className="custom-file-input"
                />
                <label
                  className="custom-file-label "
                  htmlFor="inputGroupFile01"
                >
                  {selectedFile ? selectedFile.name : <>Choose file</>}
                </label>
              </div>
            </CInputGroup>
          </CCol>
        </CRow>
        <CRow className="mb-3 ml-1">
          <CCol>
            {loading ? (
              <CSpinner className="spinner-grow" color="success" />
            ) : (
              <CButton
                color="success"
                onClick={validateData}
                disabled={disableBtn}
              >
                Import
              </CButton>
            )}
            {loadingForUpload ? (
              <CSpinner className="spinner-grow ml-3" color="success" />
            ) : (
              <CButton
                className="ml-3"
                color="success"
                onClick={UploadData}
                disabled={uploadBtn === false ? true : false}
              >
                Upload
              </CButton>
            )}
            {loadingForUpload ? (
              <CSpinner className="spinner-grow ml-3" color="success" />
            ) : (
              <CButton
                className="ml-3"
                color="success"
                onClick={UploadAgreementData}
                enabled={uploadBtn === false ? true : false}
              >
                Upload Agreement
              </CButton>
            )}
            <a href={csvFile} download="Sample Lot.csv">
              <CButton className="ml-3" color="info">
                Sample File
              </CButton>
            </a>
          </CCol>
        </CRow>
        <div className="customRedFont"> {validMsg}</div>
        {distplayStatus ? (
          <div className="scrollbar">
            <CDataTable
              fields={fields}
              items={usersData}
              responsive
              border
              scopedSlots={{
                ShowSpan: (item, index) => {
                  if (item.status === "Success")
                    return (
                      <td>
                        <span className="customGreenFont">Success</span>
                      </td>
                    );
                  if (item.status !== "Success")
                    return (
                      <td>
                        <span className="customRedFont">{item.status}</span>
                      </td>
                    );
                },
                LotNumber: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>{item.lotNo === null ? "" : item.lotNo}</span>
                    </td>
                  );
                },
              }}
            />
          </div>
        ) : (
          <></>
        )}
      </CCardHeader>
    </>
  );
};

export default LotExcel;
